/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Routing_Number_Sort_Code_SInputs */

const en_routing_number_sort_code_s = /** @type {(inputs: Routing_Number_Sort_Code_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Routing number / Sort code / SWIFT`)
};

const es_routing_number_sort_code_s = /** @type {(inputs: Routing_Number_Sort_Code_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de ruta / Código de clasificación / SWIFT`)
};

const fr_routing_number_sort_code_s = /** @type {(inputs: Routing_Number_Sort_Code_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numéro de routage / Code de tri / SWIFT`)
};

const de_routing_number_sort_code_s = /** @type {(inputs: Routing_Number_Sort_Code_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bankleitzahl / Sort Code / SWIFT`)
};

const ja_routing_number_sort_code_s = /** @type {(inputs: Routing_Number_Sort_Code_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ルーティング番号 / ソートコード / SWIFT`)
};

const zh_routing_number_sort_code_s = /** @type {(inputs: Routing_Number_Sort_Code_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`路由号码 / 银行排序代码 / SWIFT`)
};

const ar_routing_number_sort_code_s = /** @type {(inputs: Routing_Number_Sort_Code_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رقم التوجيه (Routing) / رمز الفرز (Sort code) / SWIFT`)
};

const id_routing_number_sort_code_s = /** @type {(inputs: Routing_Number_Sort_Code_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nomor Routing / Kode Sortir / SWIFT`)
};

const it_routing_number_sort_code_s = /** @type {(inputs: Routing_Number_Sort_Code_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Routing number / Sort code / SWIFT`)
};

const ru_routing_number_sort_code_s = /** @type {(inputs: Routing_Number_Sort_Code_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Routing number / Sort code / SWIFT`)
};

const pt_routing_number_sort_code_s = /** @type {(inputs: Routing_Number_Sort_Code_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de Roteamento / Sort code / SWIFT`)
};

const ko_routing_number_sort_code_s = /** @type {(inputs: Routing_Number_Sort_Code_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`라우팅 번호 / Sort Code / SWIFT`)
};

/**
* | output |
* | --- |
* | "Routing number / Sort code / SWIFT" |
*
* @param {Routing_Number_Sort_Code_SInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const routing_number_sort_code_s = /** @type {((inputs?: Routing_Number_Sort_Code_SInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Routing_Number_Sort_Code_SInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_routing_number_sort_code_s(inputs)
	if (locale === "es") return es_routing_number_sort_code_s(inputs)
	if (locale === "fr") return fr_routing_number_sort_code_s(inputs)
	if (locale === "de") return de_routing_number_sort_code_s(inputs)
	if (locale === "ja") return ja_routing_number_sort_code_s(inputs)
	if (locale === "zh") return zh_routing_number_sort_code_s(inputs)
	if (locale === "ar") return ar_routing_number_sort_code_s(inputs)
	if (locale === "id") return id_routing_number_sort_code_s(inputs)
	if (locale === "it") return it_routing_number_sort_code_s(inputs)
	if (locale === "ru") return ru_routing_number_sort_code_s(inputs)
	if (locale === "pt") return pt_routing_number_sort_code_s(inputs)
	return ko_routing_number_sort_code_s(inputs)
});